import Vue from 'vue';
import App from './App.vue';
import router from './router';
import store from './store';
import AxiosPlugin from './plugins/axios';
import vOutsideEvents from 'vue-outside-events';
import VueCarousel from 'vue-carousel';
import infiniteScroll from 'vue-infinite-scroll';
import Gallery from 'img-vuer';
import 'vue-smooth-picker/dist/css/style.css';
import SmoothPicker from 'vue-smooth-picker';
import * as VueGoogleMaps from 'vue2-google-maps'
import Echo from 'laravel-echo';
import Pusher from 'pusher-js';
import * as apis from './apis';
import VueAnalytics from 'vue-analytics'
import VueMeta from 'vue-meta'

Vue.config.productionTip = false;

Vue.use(VueMeta);
Vue.use(SmoothPicker);
Vue.use(AxiosPlugin);
Vue.use(vOutsideEvents);
Vue.use(VueCarousel);
Vue.use(infiniteScroll);
Vue.use(Gallery, {
  swipeThreshold: 100,
  isIndexShow: true,
  useCloseButton: true,
  preload: true,
});
Vue.use(VueGoogleMaps, {
  load: {
    key: process.env.VUE_APP_MIX_GOOGLE_MAPS_KEY,
    libraries: 'places',
    language: 'zh-TW',
  },
});

let echo = new Echo({
  broadcaster: 'pusher',
  key: process.env.VUE_APP_MIX_PUSHER_APP_KEY,
  cluster: process.env.VUE_APP_MIX_PUSHER_APP_CLUSTER,
  encrypted: true,
  authorizer: (channel) => ({
    authorize: async (socketId, callback) => {
      await apis.getPusherAuth({
        socket_id: socketId,
        channel_name: channel.name,
      }).then(res => {
        callback(null, res.data);
      }).catch(err => {
        apis.log({
          device_id: 'web',
          action: 'pusher_authorize_error',
          data: JSON.stringify({
            token: localStorage.getItem('token'),
            message: err.response.data,
          })
        });
        callback(new Error(`Error calling auth endpoint: ${err}`), {
          auth: ""
        });
      });
    },
  }),
});

Vue.prototype.$echo = echo;

Vue.use(VueAnalytics, {
  id: process.env.VUE_APP_GOOGLE_ANALYTICS_ID,
  router,
});

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app');
